import type { PollOptions } from './poll.types'

export function poll<T>(
  // Accept either an invoked promise or a function returning a promise
  fn: (() => Promise<T>) | Promise<T>,
  options: PollOptions = { interval: 1000, retries: 5 },
): Promise<T> {
  const { interval, retries } = options
  let attempt = 0

  return new Promise((resolve, reject) => {
    const executePoll = async () => {
      try {
        // Handle both invoked and non-invoked cases
        const result = typeof fn === 'function' ? await fn() : await fn
        resolve(result)
      } catch (error) {
        attempt += 1
        if (attempt >= retries) {
          reject(new Error('Polling reached max retries'))
        } else {
          setTimeout(executePoll, interval)
        }
      }
    }

    void executePoll()
  })
}
